export default __webpack_public_path__ + "static/media/sale.8192e9d1.svg";